// Le kell tisztázni
const MegaMenu = (function menu() {
  $('.dropdown-menu a.dropdown-toggle').on('click', function clk(e) {
    e.stopImmediatePropagation();
    if ($(this)[0].href) {
      window.location.href = $(this)[0].href;
    }
  });

  $('#PrimaryNavProfileButton').on('click', () => {
    $('#PrimaryNavMainMenu').removeClass('show');
  });

  $('.dropdown-menu a.dropdown-toggle').on('mouseover', function clk() {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show')
        .removeClass('show');
    }

    $('.dropdown-toggle').click(() => {
      $('.dropdown-menu.megamenu__dropdown.show').removeClass('show');
      $('.dropdown-toggle.megamenu__link.active').removeClass('active');
    });

    $('.dropdown-menu a.dropdown-toggle').removeClass('active');
    const { id } = $(this)[0];
    $(`[aria-labelledby=${id}]`).toggleClass('show');
    $(this).toggleClass('active');

    $(this)
      .parents('.dropdown.show')
      .on('hidden.bs.dropdown', () => {
        $('.dropdown-submenu .show').removeClass('show');
      });
    return false;
  });
}());

module.exports = MegaMenu;
